import _e from 'common/localeUtil';

const parseImageProps = (element, withScale = 3) => {
	const { imageProps } = element.dataset;
	if (imageProps) {
		try {
			const sizesConfig = JSON.parse(imageProps);
			if (!sizesConfig.width || (!sizesConfig.height && !sizesConfig.ratio)) {
				throw new Error('required to have width and height or ratio');
			}
			if (sizesConfig.width === 'auto') {
				const { offsetHeight, offsetWidth } = element;
				const ratio =
					sizesConfig.ratio && sizesConfig.ratio !== 'auto'
						? sizesConfig.ratio
						: offsetWidth / offsetHeight;
				return {
					showImageEditor: true,
					maxWidth: offsetWidth * withScale,
					cropRatio: ratio || 1,
				};
			}
			const ratio =
				sizesConfig.ratio || (sizesConfig.height && sizesConfig.width / sizesConfig.height);
			const maxHeight = sizesConfig.height || sizesConfig.width / ratio;
			return {
				showImageEditor: true,
				maxWidth: sizesConfig.width,
				maxHeight,
				cropRatio: ratio || 1,
			};
		} catch (e) {
			console.warn('parse image props exception:', e);
		}
	}
	return {};
};

const CustomImageComponent = (editor) => {
	editor.DomComponents.addType('custom-image', {
		extend: 'div',
		extendFn: [],
		extendFnView: ['onRender'],
		isComponent: (el) => el && el.classList?.contains('image-wrapper'),
		model: {
			defaults: {
				attributes: {
					class: 'image-wrapper',
					'data-image-props': '{"width": "auto", "ratio": "auto"}',
				},
				components: {
					type: 'image',
					tagName: 'img',
					attributes: {
						src: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik0yLjI4IDNMMSA0LjI3bDIgMlYxOWMwIDEuMS45IDIgMiAyaDEyLjczbDIgMkwyMSAyMS43MiAyLjI4IDNtMi41NSAwTDIxIDE5LjE3VjVhMiAyIDAgMCAwLTItMkg0LjgzTTguNSAxMy41bDIuNSAzIDEtMS4yNUwxNC43MyAxOEg1bDMuNS00LjV6Ij48L3BhdGg+CiAgICAgIDwvc3ZnPg==',
					},
					highlightable: false,
					draggable: false,
					droppable: false,
					removable: false,
					selectable: false,
					hoverable: false,
					resizable: false,
				},
			},
		},
		view: {
			onRender(props) {
				// console.log('onRender customImage', props);
				const { el, model } = props;
				let sectionId;
				if (el.classList?.contains('full-screen')) {
					// fullscreen background
					sectionId = el.id;
				} else {
					// image-wrapper image
					const selectedComponent = model.find('img')[0];
					sectionId = selectedComponent.getId();
				}

				const buttonRowDiv = document.createElement('div');
				buttonRowDiv.classList.add('editbackground-button-row');
				const changeBackgroundBtn = document.createElement('button');
				changeBackgroundBtn.value = _e('background');
				changeBackgroundBtn.innerText = _e('edit');
				changeBackgroundBtn.classList.add('editbackground-button');
				const handleEventCallback = () => {
					editor.runCommand('openChangeBackgroundDialog', {
						sectionId: `#${sectionId}`,
						...parseImageProps(el),
					});
				};
				changeBackgroundBtn.addEventListener('click', handleEventCallback);
				changeBackgroundBtn.addEventListener('touchstart', handleEventCallback);
				buttonRowDiv.appendChild(changeBackgroundBtn);

				el.append(buttonRowDiv);
			},
		},
	});
};

export default CustomImageComponent;
